import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';

const ModalEditForm = ({ modalData, editBook, deleteBook }) => {
  const [bookForm, setBookForm] = useState({
    'title': modalData.title,
    'author': modalData.author,
    'isbn': modalData.isbn,
    'publisher': modalData.publisher,
    'year': modalData.year || 0,
    'amount': modalData.amount,
    'digital_amount': modalData.digital_amount,
    "bookid": null,
  });
  const [bookFormError, setBookFormError] = useState('');

  const handleChange = (event) => {
    setBookForm({
      ...bookForm,
      [event.target.name]: event.target.value
    });
  }

  const handleSubmit = () => {
    const isBothCountersZero = Number(bookForm.amount) === 0 && Number(bookForm.digital_amount) === 0;
    if (isBothCountersZero) {
      setBookFormError('Количество бумажных и электронных копий не могут быть одновременно равны 0');
      return;
    }
    setBookFormError('');
    editBook(bookForm, modalData.id);
  }

  return (
    <form className="smallModalForm">
      <div className="captions">Редактировать добавление книги</div>
      <Row>
        <Col md={12}>
          <label className="smallInputLabel">Название книги</label>
          <input type="text" name="title" value={bookForm.title} onChange={handleChange} />
        </Col>
        <Col md={6}>
          <label className="smallInputLabel">Автор</label>
          <input type="text" name="author" value={bookForm.author} onChange={handleChange} />
        </Col>
        <Col md={6}>
          <label className="smallInputLabel">Издательство</label>
          <input type="text" name="publisher" value={bookForm.publisher} onChange={handleChange} />
        </Col>
        <Col md={6}>
          <label className="smallInputLabel">Год</label>
          <input type="text" name="year" value={bookForm.year} onChange={handleChange} />
        </Col>
        <Col md={6}>
          <label className="smallInputLabel">ISBN</label>
          <input type="text" name="isbn" value={bookForm.isbn} onChange={handleChange} />
        </Col>
        <Col md={6}>
          <label className="smallInputLabel">Количество бумажных копий</label>
          <input type="number" name="amount" min="0" max="1000000" value={bookForm.amount} onChange={handleChange} />
        </Col>
        <Col md={6}>
          <label className="smallInputLabel">Количество электронных копий</label>
          <input type="number" name="digital_amount" min="0" max="1000000" value={bookForm.digital_amount} onChange={handleChange} />
        </Col>
      </Row>
      <Row>
        <Col>
          {bookFormError && <span className="form_error">{bookFormError}</span>}
        </Col>
      </Row>
      <Row className="justify-content-end mt-2">
        <Col md={'auto'}>
          <button type="button" className="btn mr-3" onClick={() => deleteBook(modalData.id)}>Удалить книгу</button>
          <button type="button" className="btn btn-empty" onClick={handleSubmit}>Сохранить</button>
        </Col>
      </Row>
    </form>
  );
}

export default ModalEditForm;
